export const GET_SINGLE_PAGE_DATA = "ADDTIONAL_PAGES/GET_SINGLE_PAGE_DATA";
export const GET_PAGES_LIST = "ADDTIONAL_PAGES/GET_PAGES_LIST";
export const SAVE_STORE_PAGES_LIST = "ADDTIONAL_PAGES/SAVE_STORE_PAGES_LIST";
export const SAVE_DEFAULT_TEMPLATE_LIST = "ADDTIONAL_PAGES/SAVE_DEFAULT_TEMPLATE_LIST";
export const ADD_NEW_PAGE_TO_STORE_PAGES = "ADDTIONAL_PAGES/ADD_NEW_PAGE_TO_STORE_PAGES";
export const ON_SAVE_TEMPLATE_CHANGES_AS_DRAFT = "ADDTIONAL_PAGES/ON_SAVE_TEMPLATE_CHANGES_AS_DRAFT";
export const ON_PUBLISH_TEMPLATE_CHANGES = "ADDTIONAL_PAGES/ON_PUBLISH_TEMPLATE_CHANGES";
export const ON_DELETE_PAGE = "ADDTIONAL_PAGES/ON_DELETE_PAGE";
export const ON_REORDER_PAGE = "ADDTIONAL_PAGES/ON_REORDER_PAGE";
